interface IPayfiPrimaryLogo {
  width?: string;
  height?: string;
}

const PayfiPrimaryLogo = ({ width, height }: IPayfiPrimaryLogo) => {
  return (
    <svg
      width={width || '110'}
      height={height || '40'}
      viewBox="0 0 110 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.1571 20C40.1571 31.0457 31.1676 40 20.0785 40C8.98947 40 0 31.0457 0 20C0 8.95431 8.98947 0 20.0785 0C31.1676 0 40.1571 8.95431 40.1571 20Z"
        fill="#5941A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2259 11.0042C20.1342 10.5708 21.1528 10.3281 22.2254 10.3281C26.0658 10.3281 29.1794 13.4313 29.1794 17.2588C29.1794 20.2561 27.2699 22.8084 24.5969 23.7754C23.8567 24.0412 23.0585 24.1876 22.2254 24.1876C21.1528 24.1876 20.1342 23.9449 19.2259 23.5115L19.2259 30.3016H15.2734L15.2734 20.1356L10.9277 15.7612L13.7446 12.9258L15.2984 14.4899L15.6908 14.8849C16.3165 13.1772 17.596 11.7828 19.2259 11.0042ZM20.4551 19.6474C20.9498 20.0134 21.5625 20.2291 22.2254 20.2291C23.8702 20.2291 25.2057 18.8981 25.2057 17.2588C25.2057 15.6177 23.8702 14.2885 22.2254 14.2885C20.5788 14.2885 19.2452 15.6177 19.2452 17.2588C19.2452 17.9195 19.4616 18.5282 19.8269 19.0214C20.0009 19.2564 20.2077 19.4644 20.4415 19.6378H20.4435L20.4512 19.6436L20.4551 19.6474Z"
        fill="white"
      />
      <g clipPath="url(#clip0_9423_5299)">
        <path
          d="M58.2142 19.9549C58.2142 21.6491 56.8337 23.0227 55.131 23.0227C54.4428 23.0227 53.8065 22.7978 53.2924 22.4195L53.2844 22.4136C53.0483 22.2364 52.8362 22.0273 52.6581 21.7904L52.6521 21.7825C52.272 21.2728 52.0459 20.6397 52.0459 19.9549C52.0459 18.2587 53.4264 16.885 55.131 16.885C56.8337 16.887 58.2142 18.2607 58.2142 19.9549Z"
          stroke="#5941A9"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M58.2142 19.9549C58.2142 21.6491 56.8337 23.0227 55.131 23.0227C54.4428 23.0227 53.8065 22.7978 53.2924 22.4195L53.2844 22.4136C53.0483 22.2364 52.8362 22.0273 52.6581 21.7904L52.6521 21.7825C52.272 21.2728 52.0459 20.6397 52.0459 19.9549C52.0459 18.2587 53.4264 16.885 55.131 16.885C56.8337 16.887 58.2142 18.2607 58.2142 19.9549Z"
          stroke="#5941A9"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M53.2844 22.4154C53.0483 22.2382 52.8363 22.0291 52.6582 21.7922L53.2844 22.4154Z"
          stroke="#5941A9"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M55.1283 12.7937C54.0179 12.7937 52.9635 13.0445 52.0231 13.4925C50.3325 14.2988 49.006 15.7441 48.3598 17.514C48.0837 18.2765 47.9316 19.0987 47.9316 19.9567V33.4366H52.0231V26.419C52.9635 26.8669 54.0179 27.1177 55.1283 27.1177C55.9906 27.1177 56.8169 26.9664 57.5832 26.6917C60.3502 25.6923 62.3269 23.0545 62.3269 19.9567C62.3269 15.9989 59.1038 12.7937 55.1283 12.7937ZM55.1303 23.0246C54.442 23.0246 53.8058 22.7996 53.2916 22.4214L53.2836 22.4154C53.0475 22.2382 52.8354 22.0292 52.6574 21.7923L52.6514 21.7843C52.2712 21.2746 52.0452 20.6416 52.0452 19.9567C52.0452 18.2605 53.4257 16.8869 55.1303 16.8869C56.8329 16.8869 58.2134 18.2605 58.2134 19.9567C58.2134 21.6489 56.8329 23.0246 55.1303 23.0246Z"
          fill="#5941A9"
        />
        <path
          d="M73.7877 13.4845C72.8533 13.0406 71.8069 12.7937 70.7025 12.7937C69.5921 12.7937 68.5377 13.0445 67.5974 13.4925C65.9067 14.2988 64.5803 15.7441 63.934 17.514C63.6579 18.2765 63.5059 19.0987 63.5059 19.9567C63.5059 22.8056 65.1765 25.2663 67.5974 26.419C68.5377 26.8669 69.5921 27.1177 70.7025 27.1177C71.5648 27.1177 72.3911 26.9664 73.1574 26.6917C73.3735 26.6141 73.5836 26.5265 73.7877 26.4269C76.0565 25.3559 77.6691 23.1421 77.8792 20.5321V19.3853C77.6711 16.7714 76.0565 14.5536 73.7877 13.4845ZM70.7025 23.0246C68.9979 23.0246 67.6174 21.6509 67.6174 19.9567C67.6174 18.2605 68.9979 16.8869 70.7025 16.8869C72.4071 16.8869 73.7877 18.2605 73.7877 19.9567C73.7877 21.6489 72.4071 23.0246 70.7025 23.0246Z"
          fill="#5941A9"
        />
        <path
          d="M73.7875 19.9549C73.7875 21.6491 72.407 23.0227 70.7023 23.0227C68.9977 23.0227 67.6172 21.6491 67.6172 19.9549C67.6172 18.2587 68.9977 16.885 70.7023 16.885C72.407 16.885 73.7875 18.2607 73.7875 19.9549Z"
          stroke="#5941A9"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M77.8796 20.53V28.131H73.7881V26.4249C76.0569 25.3538 77.6695 23.14 77.8796 20.53Z"
          fill="#5941A9"
        />
        <path
          d="M93.8114 12.7957L89.5358 22.3258L87.295 27.3188L84.55 33.4366H80.0703L85.0542 22.3258L87.295 17.3308L89.3297 12.7957H93.8114Z"
          fill="#5941A9"
          stroke="#5941A9"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M86.9408 22.2222L84.7 27.2172L82.4592 22.2222L78.1836 12.6941H82.6653L84.7 17.2292L86.9408 22.2222Z"
          fill="#5941A9"
        />
        <path
          d="M102.688 6.72927C101.92 6.58619 101.128 6.51465 100.313 6.51465C99.1136 6.51465 98.1541 6.68157 96.9069 7.37312C95.7315 8.01697 94.916 9.5193 94.916 11.6893V12.2139L94.916 12.3962L94.916 14.9508V15.9101V27.0703H99.4974V15.9101H102.688V12.2139H99.4974V11.6655C99.4974 11.2839 99.4974 10.9501 100.073 10.5208C100.673 10.0916 101.776 10.1155 102.688 10.4255H102.712V6.72927H102.688ZM104.774 12.2139V27.0703H109.308V12.2139H104.774Z"
          fill="#5941A9"
        />
        <path
          d="M106.941 11.0298C108.19 11.0298 109.203 10.019 109.203 8.7722C109.203 7.52539 108.19 6.51465 106.941 6.51465C105.692 6.51465 104.679 7.52539 104.679 8.7722C104.679 10.019 105.692 11.0298 106.941 11.0298Z"
          fill="#5941A9"
        />
      </g>
      <defs>
        <clipPath id="clip0_9423_5299">
          <rect
            width="61.4358"
            height="26.9718"
            fill="white"
            transform="translate(47.8867 6.51465)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default PayfiPrimaryLogo;
